//* 组件库
import { $loading } from "various-ui";
//* 组件属性
import type { ModuleData, ModuleGenes, ModuleInfo } from "../index";
import type { DefaultPropsTypes } from "../../../index";
import { useOptions } from "./options";
//* 样式
import css from "../style/index.module.less";

export const useComposable = (define: DefaultPropsTypes) => {
    //* 插件
    const i18n = useI18n();
    const route = useRoute();

    //* 配置项
    const options = useOptions();

    //* 响应式变量
    const refs = {
        data: ref<ModuleInfo[][]>([]),
        exist: ref<boolean>(true),
        loading: ref<boolean>(true),
        selectors: reactive<ModuleGenes[]>([]),
    };

    //* 节点
    const nodes = {
        body: ref<HTMLDivElement>(),
    };

    //* 函数列表
    const methods = {
        //* 渲染函数
        render: (data: ModuleData) => {
            //* 数据初始化
            refs.loading.value = false;
            refs.data.value = data.comparison || [];
            refs.selectors.push({ species: define.origin.species, value: route.params.id?.toString() || "", name: define.origin.symbol });
            options.selectors
                .filter((value) => value.species != define.origin.species)
                .forEach((value) => {
                    const response = data.homologous.find((v) => v.species == value.species);
                    if (response) refs.selectors.push(response);
                    else {
                        refs.selectors.push({ species: value.species, value: "", name: "" });
                    }
                });
        },

        //* 隐藏函数
        hidden: () => {
            refs.exist.value = false;
            refs.loading.value = false;
        },

        //* 序列比对
        comparison: (data: any) => {
            api.frontend("/api/gene/homologys/comparison-link", {
                method: "POST",
                data: data,
                success: (response) => {
                    open(routerResolve({ name: "SequenceAlignmentResult", query: { uuid: response.data.job_id } }).href as string, "_blank");
                },
            });
        },
    };

    return { refs, nodes, methods, options };
};
